/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';

const styles = ({ palette, typography }) => ({
  error: {
    color: palette.error,
  },
  left: {
    textAlign: 'left',
  },
  table: {
    '& td': {
      padding: 5,
    },
    '& th': {
      fontWeight: typography.fontWeights.bold,
      padding: 5,
    },
    fontSize: 16,
    margin: [0, 'auto'],
    maxWidth: 440,
    position: 'relative',
    right: -10,
    textAlign: 'center',
    width: '100%',
  },
});

const SignerstatusRequirements = ({ classes, resources, rules }) =>
  rules && (
    <div>
      <table className={classnames('signerstatus-table', classes.table)}>
        <thead>
          <tr>
            <th className={classes.left}>{resources.roleType}</th>
            <th>{resources.assigned}</th>
            <th>{resources.required}</th>
            <th>{resources.maximum}</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((row) => (
            <tr
              key={row.applicantRoleType}
              className={classnames({
                [classes.error]: row.assigned < row.required || row.assigned > row.maximum,
                error: row.assigned < row.required || row.assigned > row.maximum,
              })}
            >
              <td className={classnames('left', classes.left)}>
                {resources[row.applicantRoleType]}
              </td>
              <td>{row.assigned}</td>
              <td>{row.required}</td>
              <td>{row.maximum}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

SignerstatusRequirements.propTypes = {
  resources: PropTypes.shape({
    assigned: PropTypes.string,
    maximum: PropTypes.string,
    required: PropTypes.string,
    roleType: PropTypes.string,
  }),
  rules: PropTypes.arrayOf(PropTypes.shape({})),
};

SignerstatusRequirements.defaultProps = {
  resources: {},
  rules: [],
};

const SignerstatusRequirementsStyled = withStyles(styles)(SignerstatusRequirements);

const mapStateToProps = ({ groups }) => ({
  resources: groups.BUSINESS_USERS?.resources,
  rules: groups.BUSINESS_USERS?.listGroup?.rules,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SignerstatusRequirementsStyled);
